import { render, staticRenderFns } from "./TradesList.vue?vue&type=template&id=bf06bf18&scoped=true&"
import script from "./TradesList.vue?vue&type=script&lang=ts&"
export * from "./TradesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf06bf18",
  null
  
)

export default component.exports